import { render, staticRenderFns } from "./createGoldLabel.vue?vue&type=template&id=63a0ae3f&scoped=true"
import script from "./createGoldLabel.vue?vue&type=script&lang=js"
export * from "./createGoldLabel.vue?vue&type=script&lang=js"
import style0 from "./createGoldLabel.vue?vue&type=style&index=0&id=63a0ae3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0ae3f",
  null
  
)

export default component.exports